import { useMutation } from "@tanstack/react-query";
import { useOrderContext } from "app/providers/OrderProvider";
import { api } from "shared/api";
import { getFormattedBumbalRequest } from "shared/utils/date";

export const useCreateBumbalDate = () => {
  const { order, type } = useOrderContext();

  const createBumbalDate = async (selectedDate: Date | null) => {
    if (!selectedDate) return;

    if (!order) return;
    const res = await api().gersCreateBumbalDate(order.id, {
      dateFrom: getFormattedBumbalRequest(selectedDate).dateFrom,
      dateTo: getFormattedBumbalRequest(selectedDate).dateTo,
      type: type,
    });

    return res.data;
  };

  const {
    mutate: mutateBumbalDate,
    isLoading: isCreatingBumbalDate,
    isError: createBumbalDateFailed,
    status: bumbalDateCreateStatus,
  } = useMutation(createBumbalDate);

  return {
    mutateBumbalDate,
    isCreatingBumbalDate,
    createBumbalDateFailed,
    bumbalDateCreateStatus,
  };
};
